var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./CommonStoryDownloads.jinja');
require('./CommonStoryDownloads.less');

module.exports = Base.extend({

    template: template,


    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonStory/CommonStoryDownloads.js
// module id = 167
// module chunks = 0